import { ApiFactory } from "@/api/ApiFactory.js";
const WidgetApi = ApiFactory.get("widgets");

export default {
    props: ["url"],
    data() {
        return {
            busy: false
        };
    },
    created() {
        this.fetch();
    },
    methods: {
        async fetch(setBusy = true) {
            this.busy = setBusy && true;
            const response = await WidgetApi.getWidgetData(this.url);
            if (response.ok) {
                this.process(response.json);
            }
            this.busy = false;
        },
        process(items) {}
    }
};
